import { gql } from '@apollo/client';

//Query for intro splash
export const userInformationQuery = gql`
  query getUserInfo {
    userAccountInfo {
      experiencesPage(limit: 1) {
        cursor
        experiences {
          id
          experienceSKU
          contentPolicySKUs
          featurePolicies
        }
      }
    }
  }
`;
